import { render, staticRenderFns } from "./apartment-special-equipment.vue?vue&type=template&id=5cb72d48&scoped=true&"
import script from "./apartment-special-equipment.ts?vue&type=script&lang=ts&"
export * from "./apartment-special-equipment.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-special-equipment.scss?vue&type=style&index=0&id=5cb72d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb72d48",
  null
  
)

export default component.exports